<template>  
    <div class="copyright">
        <p>版权所有：贵州省音乐家协会</p>
        <p>客服电话： <a href="tel:18302574003">18302574003</a>、<a href="tel:085185823989">0851-85823989</a>、<a href="tel:‭085185281003‬">‭0851-85281003‬‬</a></p>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>